<template>
  <div class="moz-input-container">
    <input
      :id="id"
      type="text"
      :class="['moz-input', inputClasses]"
      :placeholder="placeholder"
      :value="value"
      :name="name"
      @input="handleInput"
      @focus="handleFocus"
    >
    <div
      v-if="error"
      class="moz-error"
    >
      <span class="moz-error__inner">
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MozInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Laguna Hotel',
    },
    error: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputClasses() {
      return {
        '_has-error': this.error,
      };
    },
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value);
    },
    handleFocus(event) {
      this.$emit('focus', event);
    },
  },
};
</script>

<style lang="scss" scoped>
$border-radius: 6px;
$red: #e34a14;
$error-color: $red;

.moz-input-container {
  position: relative;
}

.moz-input {
  position: relative;
  z-index: 2;
  display: block;
  width: 100%;
  max-width: 752px;
  padding: 13px 11px;
  border-radius: $border-radius;
  border: solid 1px #e4e7ea;
  font-size: 15px;
  line-height: 1;

  &:hover {
    box-shadow: inset 0 0 0 1px #b6bec7;
    border: solid 1px #b6bec7;
  }

  &:focus {
    box-shadow: inset 0 0 0 1px #fabe31;
    border: solid 1px #fabe31;
  }

  &._has-error {
    box-shadow: inset 0 0 0 1px $error-color;
    border: solid 1px $error-color;
    outline: none;
  }

  @media screen and (min-width: $tablet-width) {
    padding: 13px 16px;
  }
}

.moz-error {
  position: relative;
  z-index: 1;
  margin-top: -5px;
  left: 0;
  background-color: $error-color;
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;

  &__inner {
    display: block;
    padding: 8px;
    font-size: 9px;
    line-height: 1.3;
    color: #fff;
  }

  @media screen and (min-width: $tablet-width) {
    position: absolute;
    z-index: 1;
    top: 42px;
    left: 0;
    margin-top: 0;
    background-color: transparent;
    border-radius: 0;

    &__inner {
      display: block;
      font-size: 12px;
      font-weight: 600;
      background-color: $error-color;
      border-bottom-left-radius: $border-radius;
      border-bottom-right-radius: $border-radius;
    }
  }
}

/* stylelint-disable */
// change placeholder color https://webref.ru/css/placeholder
input[type='text']::-moz-placeholder {
  color: #E4E7EA;
}

input[type='text']::-webkit-input-placeholder {
  color: #E4E7EA;
}

input[type='text']:-ms-input-placeholder {
  color: #E4E7EA;
}

input[type='text']::-ms-input-placeholder {
  color: #E4E7EA;
}

input[type='text']::placeholder {
  color: #E4E7EA;
}
</style>
